import { Button, CardMedia, Input, TextField, MenuItem, Select, FormControl, InputLabel, Switch, FormControlLabel } from "@mui/material";
import { useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import { ChangeEvent, useState } from "react";

const AddKnowledgeBase = () => {
    const navigate = useNavigate();

    // Icon preview
    const [icon, setIcon] = useState<string>("");
    const [fileName, setFileName] = useState<string>("");

    // Form fields
    const [title, setTitle] = useState<string>("");
    const [description, setDescription] = useState<string>("");
    const [readingDuration, setReadingDuration] = useState<string>("");
    const [category, setCategory] = useState<string>("User Onboarding");
    const [isVisible, setIsVisible] = useState<boolean>(true);

    return (
        <>
            {/* Page Title */}
            <div className="main_title">
                <h1>Add Knowledge Base</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
                    <button onClick={() => navigate("/knowledge-base")}>
                        Knowledge Base
                    </button>{" "}
                    - Add
                </p>
            </div>

            {/* Form */}
            <form className="form cards">
                <div className="gap_p">

                    {/* Upload Icon */}
                    <div className="control_group w_100">
                        <label htmlFor="icon-upload">
                            Upload Icon<span className="req">*</span>
                        </label>

                        {icon ? (
                            <div className="upload_image">
                                <div className="upload_image_holder no_radius v2">
                                    <figure>
                                        <CardMedia
                                            component="img"
                                            image={icon}
                                            alt="icon"
                                            sx={{ maxWidth: 120 }}
                                        />
                                    </figure>

                                    <CloseIcon
                                        onClick={() => {
                                            setIcon("");
                                            setFileName("");
                                        }}
                                    />
                                </div>
                            </div>
                        ) : (
                            <label className="upload_image" htmlFor="icon-upload">
                                <Input
                                    sx={{ display: "none" }}
                                    id="icon-upload"
                                    type="file"
                                    inputProps={{ accept: "image/png,image/jpeg,image/svg+xml" }}
                                    onChange={(event: ChangeEvent<HTMLInputElement>) => {
                                        const files = event.target.files;
                                        if (files && files[0].type.includes("image")) {
                                            setFileName(files[0].name);
                                            setIcon(URL.createObjectURL(files[0]));
                                        }
                                    }}
                                />

                                <span className="upload_image_holder no_radius">
                                    <figure className="add_img">
                                        <img src="/static/images/placeholder.png" alt="icon" />
                                        <span className="upload_img_icon">
                                            <img src="/static/images/edit2_icon.svg" alt="upload" />
                                        </span>
                                    </figure>
                                </span>
                            </label>
                        )}
                    </div>

                    {/* Category & Visibility */}
                    <div className="control_group w_50">
                        <label htmlFor="kb-category">
                            Category<span className="req">*</span>
                        </label>
                        <Select
                            id="kb-category"
                            value={category}
                            onChange={(e) => setCategory(e.target.value)}
                            fullWidth
                            size="small"
                        >
                            <MenuItem value="User Onboarding">User Onboarding</MenuItem>
                            <MenuItem value="Vendor Onboarding">Vendor Onboarding</MenuItem>
                            <MenuItem value="AI Tools">AI Tools</MenuItem>
                            <MenuItem value="General">General</MenuItem>
                        </Select>
                    </div>

                    <div className="control_group w_50" style={{ display: 'flex', alignItems: 'center', paddingTop: '30px' }}>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={isVisible}
                                    onChange={(e) => setIsVisible(e.target.checked)}
                                />
                            }
                            label="Make this content public"
                        />
                    </div>

                    {/* Title */}
                    <div className="control_group w_50">
                        <label htmlFor="kb-title">
                            Title<span className="req">*</span>
                        </label>
                        <TextField
                            id="kb-title"
                            placeholder="Enter title"
                            fullWidth
                            hiddenLabel
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                        />
                    </div>
                    <div className="control_group w_50">
                        <label htmlFor="reading-duration">
                            Reading Duration<span className="req">*</span>
                        </label>
                        <TextField
                            id="reading-duration"
                            placeholder="e.g. 5 min read"
                            fullWidth
                            hiddenLabel
                            value={readingDuration}
                            onChange={(e) => setReadingDuration(e.target.value)}
                        />
                    </div>
                    {/* Description */}
                    <div className="control_group w_100">
                        <label htmlFor="kb-description">
                            Description<span className="req">*</span>
                        </label>
                        <TextField
                            id="kb-description"
                            placeholder="Enter description"
                            fullWidth
                            hiddenLabel
                            multiline
                            rows={4}
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                        />
                    </div>

                    {/* Reading Duration */}


                    {/* Footer Buttons */}
                    <div className="footer_btn_flex">
                        <Button className="btn btn_primary">
                            Save
                        </Button>
                    </div>

                </div>
            </form>
        </>
    );
};

export default AddKnowledgeBase;
